import { RefObject, useEffect } from 'react';

export interface IUseElementScrollTrackerProps {
  trigger: boolean;
  ref: RefObject<HTMLElement>;
  callback?: (...args: any[]) => void;
}

const useElementScrollTracker = ({ trigger, ref, callback }: IUseElementScrollTrackerProps) => {
  useEffect(() => {
    if (trigger && ref.current) {
      const { scrollTop, clientHeight, scrollHeight } = ref.current;
      if (scrollTop === 0 && clientHeight === scrollHeight && trigger) {
        void callback?.();
      }
    }
  }, [trigger, callback]);
  return null;
};

export default useElementScrollTracker;
